import { useMemo } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import RMasonry from 'react-masonry-css'

import MasonryItem from './MasonryItem'
import MasonryVideoItem from './MasonryVideoItem'
import { BlockSectionTitle, BlockWrapper, Container } from 'common/widgets'
import classNames from './styles.module.scss'


Masonry.propTypes = {
  data: PropTypes.shape({
    heading: PropTypes.string,
    heading_hx: PropTypes.string,
    columns: PropTypes.arrayOf(
      PropTypes.oneOfType([
        PropTypes.shape({
          image: PropTypes.object,
          tag: PropTypes.string,
          date: PropTypes.string,
          heading: PropTypes.string,
          text: PropTypes.string,
          cta_url: PropTypes.string,
          cta_link_caption: PropTypes.string,
        }),
        PropTypes.shape({
          videoId: PropTypes.string.isRequired,
          videoTitle: PropTypes.string.isRequired,
        }),
      ]),
    ),
  }),
  headingTag: PropTypes.string,
  noTopMargin: PropTypes.bool,
}

export default function Masonry({
  data = {
    columns: [],
  },
  headingTag = undefined,
  noTopMargin = false,
}) {
  const items = useMemo(
    () =>
      get(data, 'columns', []).map((option, index) => {
        if(option.videoId) {
          return (
            <MasonryVideoItem
              key={index}
              videoId={option.videoId}
              videoTitle={option.videoTitle}
            />
          )
        }
        return (
          <MasonryItem
            key={index}
            cta={option.cta_link_caption}
            headingTag={headingTag}
            {...option}
          />
        )
      }),
    [data?.columns, headingTag],
  )
  const breakpointColumnsObj = useMemo(
    () => ({
      default: 3,
      1024: 2,
      576: 1,
    }),
    [],
  )

  return (
    <BlockWrapper noTopMargin={noTopMargin}>
      <Container size="xl">
        <BlockSectionTitle heading={data.heading} headingHx={data.heading_hx} />
        <RMasonry
          breakpointCols={breakpointColumnsObj}
          className={classNames.container}
          columnClassName={classNames.column}
        >
          {items}
        </RMasonry>
      </Container>
    </BlockWrapper>
  )
}
